export const checkIsShowAccordionBlockEditIcon = (
  isOpen: boolean,
  isFullFilled: boolean,
  isDisableEdit: boolean,
  shouldForceOpenPopup: boolean,
): boolean => {
  if (isDisableEdit) {
    // если отключили редактирование - то дальше нет смысла анализировать
    return false;
  }

  if (shouldForceOpenPopup) {
    // если принудительно открываем попап с редактирование - то карандашик можно показать
    return true;
  }

  // Если блок аккордиона свернут и данные в нем готовы к редактированию - то выводим карандашик
  return !isOpen && isFullFilled;
};
